<template>
  <v-app>
    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer padless dark>
      <v-col
        class="text-center white--text" cols="12" >
        {{ new Date().getFullYear() }} — <strong>svtr.dev</strong>
        | download the svtr.dev internal root CA here: <a href="/svtrInternalCA.pem">PEM format</a> or  <a href="/svtrInternalCA.crt">DER format</a>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  components: {},

  data: () => ({
    //
  }),
};
</script>

